import { useSubsequentEffect } from '@carvana/vdp-react-hooks';
import Router from 'next/router';
import { useContext, useEffect } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import InventoryContext from '~/contexts/InventoryContext';
import SEOContext from '~/contexts/SEOContext';
import useGenerateInventoryRequest from '~/hooks/useGenerateInventoryRequest';

function usePageNumberFromInventory() {
  const {
    inventory: {
      data: {
        inventory: {
          pagination: { currentPage }
        }
      }
    }
  } = useContext(InventoryContext);

  return currentPage;
}

export default function useSetPageNumber() {
  const { pageNumber, setPageNumber } = useContext(AppliedFiltersContext);
  const { setChanged } = useContext(SEOContext);
  const pageNumberFromInventory = usePageNumberFromInventory();

  const inventoryRequest = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT, {
    includeAnalyticsData: false,
    includePageNumber: false
  });

  // Update URL
  useEffect(() => {
    const url = new URL(window.location.href);

    if (pageNumber <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(pageNumber));
    }

    if (window.location.href !== url.toString()) {
      void Router.push(url, undefined, { shallow: true });
    }
  }, [pageNumber]);

  // Reset when something changes, e.g. filters, sort, or trade-in
  useSubsequentEffect(() => {
    setChanged();
    setPageNumber(1);
  }, [inventoryRequest, setChanged, setPageNumber]);

  // Synchronize with Search API response
  useSubsequentEffect(() => {
    if (pageNumberFromInventory) {
      setPageNumber(pageNumberFromInventory);
    }
  }, [pageNumberFromInventory, setPageNumber]);
}
